module.exports = __webpack_public_path__ + "static/img/07.90a8f0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/07.jpg
// module id = 3SaR
// module chunks = 0